export type ProductCategory = {
  id: number;
  displayName: string;
  parent?: number;
};
export type ProductCategoryByBrand = {
  id: number;
  categoryName: string;
};

export type ProductBrand = {
  id: number;
  displayName: string;
};

export type ProductSearchQuery = {
  motorcyclesOnly?: boolean;
  search: string;
  brand?: string;
};

export type CreateCustomProductReq = {
  model: string;
  // number (id) if using existing option, string (name) if creating
  // a new option
  category: number | string;
  brand: number | string;
};

export type Product = {
  id: string;
  category: ProductCategory;
  name: string;
  description?: string;
  ean?: string;
  upc?: string;
  elid?: string;
  asin?: string;
  brand?: string;
  model?: string;
  dimension?: string;
  weight?: string;
  size?: string;
  imageUrl?: string;
  color?: string;
  source?: string;
  userManual?: string;
};

export type ProductSearchV1Res = {
  imageUrl: string;
  id: string;
  model: string;
  brand: string;
  upc: string;
};

export type ProductFromSearchV1 = {
  imageUrl: string;
  id: string;
  isNewDatabaseProduct: true;
  model: string;
  brand: string;
  name: string;
  upc: string;
};

export const searchResToProductFromSearchV1 = (
  res: ProductSearchV1Res[]
): ProductFromSearchV1[] =>
  res.map(p => ({
    ...p,
    isNewDatabaseProduct: true,
    name: `${p.brand} ${p.model}`,
  }));
